"use strict";
module.exports = require('../../module.compiled').vendored['react-rsc'].React;

//# sourceMappingURL=react.js.map